import { render, staticRenderFns } from "./LKRoadmapsFeedTree.vue?vue&type=template&id=64bf9c9e&"
import script from "./LKRoadmapsFeedTree.vue?vue&type=script&lang=js&"
export * from "./LKRoadmapsFeedTree.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports